import React from "react";
import { useHistory } from "react-router";
import { Modal } from "Components/Modals/Modal";
import { Button } from "Components/Button";
import { ProductRuleList } from "Requests/ProductsRules";
import { ClientProductRulesList } from "./ClientProductRulesList";
import * as S from "./styles";

interface ModalRuleDetailsProps {
  isOpen: boolean;
  onClose: () => void;
  ruleSet: ProductRuleList | null;
}

export const ModalRuleDetails = ({
  isOpen,
  onClose,
  ruleSet,
}: ModalRuleDetailsProps) => {
  const history = useHistory();

  const handleEdit = () => {
    onClose();
    if (ruleSet) {
      history.push(`/regras/regras-produto/editar/${ruleSet.id}`);
    }
  };

  if (!ruleSet) return null;

  return (
    <Modal
      isOpen={isOpen}
      requestClose={onClose}
      closeOverlay
      closeIcon
      maxWidth="1000"
      maxHeight="800"
      renderHeading={() => (
        <h2 className="text-semibold">Detalhes regra de produto</h2>
      )}
      renderDescription={() => (
        <S.Container>
          <div>
            <h2>Produto</h2>
            <p className="text-gray" style={{ margin: "4px 0 0" }}>
              {ruleSet.product_name || "Sem produto selecionado"}
            </p>
          </div>
          <div>
            <h2>Sinônimos</h2>
            <p className="text-gray" style={{ margin: "4px 0 0" }}>
              {ruleSet.synonyms}
            </p>
          </div>
          <div>
            <h2>Regras por operação</h2>
            {ruleSet.rules?.map((rule) => (
              <ClientProductRulesList key={rule.client_id} rule={rule} />
            ))}
          </div>
        </S.Container>
      )}
      renderActions={() => (
        <div
          style={{
            display: "flex",
            gap: 12,
            paddingBottom: 30,
            marginTop: "auto",
          }}
        >
          <Button type="button" borderRadius="111" onClick={handleEdit}>
            Editar
          </Button>
          <Button type="button" outlined borderRadius="111" onClick={onClose}>
            Fechar
          </Button>
        </div>
      )}
    />
  );
};
